<div class="container-fluid glb-popup">
  <h2> {{formTitle}}</h2>
  <p-toast [style]="{marginTop: '80px'}">
  </p-toast>
  <p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>
  @if (formLoading) {
  <div class="progress-spinner">
    <app-spinner [formLoading]="formLoading"></app-spinner>
  </div>
  }

  <button mat-icon-button [mat-dialog-close]="true" style="float:right;top:-50px;background-color: transparent;">
    <i class="pi pi-times" aria-hidden="true"></i>
  </button>
  <hr>
    <div [formGroup]="form1" class="forms w-100 d-block">
      <div class="row">

        <div class="col-lg-12">
          @if (formAlert) {
            <div class="w-100 mb-3">
              <div class="w-100"
                style="text-align: center; background-color: yellow;padding:5px;margin-bottom:15px;">
                <p><b>{{formAlert}}</b></p>
              </div>
            </div>
          }
        </div>

        <div class="col-lg-3">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="itemName" id="itemName" type="text" pInputText>
            <label for="itemName">Item Name</label>
            @for (validation of validationMessages.itemName; track validation) {
              <span>
                @if (form1.get('itemName').hasError(validation.type) && (form1.get('itemName').dirty || form1.get('itemName').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-3">
          <span class="p-float-label w-100 mb-3">
            <app-reservation-select [placeholder]="'Enter Reservation ID & Select Reservation'"
              (reservationInfoEvent)="reservationInfoItem($event)" [title]="title"
            [reservationId]="reservationId"> </app-reservation-select>
            <span>
              @if (isReservationId) {
                <small class="p-invalid">Reservation is required
                </small>
              }
            </span>
          </span>
        </div>

        <!-- <div class="col-lg-6">
        <span class="p-float-label required-field w-100 mb-3">
          <p-dropdown dropdownIcon="fa fa-caret-down" [options]="properties" formControlName="shortTermRentalId" optionLabel="propertyCode"
            optionValue="shortTermRentalId" [filter]="true" filterBy="propertyCode" [showClear]="false"
            placeholder="Select Property">
          </p-dropdown>
          <label for="Select Property">Select Property</label>
          <span *ngFor="let validation of validationMessages.shortTermRentalId">
            <small class="p-invalid"
              *ngIf="form1.get('shortTermRentalId').hasError(validation.type) && (form1.get('shortTermRentalId').dirty || form1.get('shortTermRentalId').touched)">{{validation.message}}
            </small>
          </span>
        </span>
      </div> -->
    </div>

    <div class="row">
      <div class="col-lg-2">
        <span class="p-float-label w-100 mb-3">
          <p-dropdown dropdownIcon="fa fa-caret-down" class="w-100" [options]="statuses"
            formControlName="status" optionLabel="name" optionValue="value"
          placeholder="Status"></p-dropdown>
          <label for="Status">Status</label>
          @for (validation of validationMessages.status; track validation) {
            <span>
              @if (form1.get('status').hasError(validation.type) && (form1.get('status').dirty || form1.get('status').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-2">
        <span class="p-float-label w-100 mb-3">
          <p-calendar appendTo="body" formControlName="returnDate" inputId="returnDate">
          </p-calendar>
          <label for="returnDate">Return Date</label>
          @for (validation of validationMessages.returnDate; track validation) {
            <span>
              @if (form1.get('returnDate').hasError(validation.type) && (form1.get('returnDate').dirty || form1.get('returnDate').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>


      <div class="col-lg-2">
        <span class="p-float-label required-field w-100 mb-3">
          <input formControlName="trackingNumber" id="trackingNumber" type="text" pInputText>
          <label for="trackingNumber">Tracking Number</label>
          @for (validation of validationMessages.trackingNumber; track validation) {
            <span>
              @if (form1.get('trackingNumber').hasError(validation.type) && (form1.get('trackingNumber').dirty || form1.get('trackingNumber').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-6">
        <span class="p-float-label w-100 mb-3">
          <textarea formControlName="itemDesc" id="itemDesc" [rows]="2" pInputTextarea></textarea>
          <label for="itemDesc">Item Description</label>
          @for (validation of validationMessages.itemDesc; track validation) {
            <span>
              @if (form1.get('itemDesc').hasError(validation.type) && (form1.get('itemDesc').dirty || form1.get('itemDesc').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-6">
        <span class="p-float-label w-100 mb-3">
          <textarea formControlName="opsNotes" id="opsNotes" [rows]="5" pInputTextarea></textarea>
          <label for="opsNotes">Options Notes</label>
          @for (validation of validationMessages.opsNotes; track validation) {
            <span>
              @if (form1.get('opsNotes').hasError(validation.type) && (form1.get('opsNotes').dirty || form1.get('opsNotes').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-2">
        <!-- <h6 for="guestInquired">Guest Inquired Options</h6> -->
        <div class="flex align-items-center">
          <p-checkbox [formControl]="form1.controls['guestInquired']" inputId="guestInquired"
          [binary]="true"></p-checkbox>
          <span class="lostFound-nm">Is Guest Inquired?</span>
        </div>
        @for (validation of validationMessages.guestInquired; track validation) {
          <span>
            @if (form1.get('guestInquired').hasError(validation.type) && (form1.get('guestInquired').dirty || form1.get('guestInquired').touched)) {
              <small class="p-invalid"
                >{{validation.message}}
              </small>
            }
          </span>
        }
      </div>

      <div class="col-lg-2">
        <!-- <h6 for="guestNotified">Guest Notified Options</h6> -->
        <div class="flex align-items-center">
          <p-checkbox [formControl]="form1.controls['guestNotified']" inputId="guestNotified"
          [binary]="true"></p-checkbox>
          <span class="lostFound-nm">Is Guest Notified?</span>
        </div>
        @for (validation of validationMessages.guestNotified; track validation) {
          <span>
            @if (form1.get('guestNotified').hasError(validation.type) && (form1.get('guestNotified').dirty || form1.get('guestNotified').touched)) {
              <small class="p-invalid"
                >{{validation.message}}
              </small>
            }
          </span>
        }
      </div>

      <div class="col-lg-2">
        <!-- <h6 for="itemReturned">Item Returned Options</h6> -->
        <div class="flex align-items-center">
          <p-checkbox [formControl]="form1.controls['itemReturned']" inputId="itemReturned" [binary]="true"></p-checkbox>
          <span class="lostFound-nm">Is Item Returned?</span>
        </div>
        @for (validation of validationMessages.itemReturned; track validation) {
          <span>
            @if (form1.get('itemReturned').hasError(validation.type) && (form1.get('itemReturned').dirty || form1.get('itemReturned').touched)) {
              <small class="p-invalid"
                >{{validation.message}}
              </small>
            }
          </span>
        }
      </div>
    </div>

  </div>
  <hr>
    <div class="row m-0">
      <div class="col-lg-12">
        <div class="btn-group">
          <div class="button-group">
            @if (lostFoundId) {
              <button pButton class="btn-delete p-button-outlined p-button-danger"
              [disabled]="formLoading" (click)="onFormDelete()">Delete Lost Found</button>
            }
          </div>

          <div class="button-group">
            <button pButton class="btn-cancel p-button-text" [disabled]="formLoading" [mat-dialog-close]="formLoading ? null : true">Cancel</button>
            @if (!lostFoundId) {
              <button pButton class="btn-addt p-button" [disabled]="formLoading" (click)="formAdd()">
                @if (formLoading) { <i class="pi pi-spin pi-spinner mr-1"></i> } Add Lost Found
              </button>
            }

            @if (lostFoundId) {
              <button pButton class="btn-upt p-button" [disabled]="formLoading" (click)="formUpdate()">
                @if (formLoading) { <i class="pi pi-spin pi-spinner mr-1"></i> } Update Lost Found
              </button>
            }
          </div>
        </div>
      </div>
    </div>
  </div>